// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","github":"Footer_github__Kdml6","linkedin":"Footer_linkedin__B2f9q"};